import { render } from "./DataTable.vue?vue&type=template&id=7286943c&scoped=true&ts=true"
import script from "./DataTable.vue?vue&type=script&lang=ts"
export * from "./DataTable.vue?vue&type=script&lang=ts"

import "./DataTable.vue?vue&type=style&index=0&id=7286943c&lang=scss&scoped=true"

import exportComponent from "/opt/pptcopilot/app/ppt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7286943c"]])

export default __exports__